"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _hexToAlpha = require("../../util/hexToAlpha");
var _spaceMixin = require("../spaceMixin");
/** @class TabMixin */
/** @method */
var TabMixin = function TabMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Tabs.backgroundColor',
    fontWeight: 'Tabs.Tab.fontWeight',
    borderWidth: 'Button.borderWidth'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      fontWeight = _ref.fontWeight,
      borderWidth = _ref.borderWidth;
    return (0, _styledComponents.css)(["background-color:", ";border-radius:0;font-weight:", ";justify-content:flex-start;overflow:hidden;white-space:nowrap;&:hover:not(:disabled){cursor:pointer;}&[aria-selected='false']:before{background:linear-gradient( 90deg,", " 0%,", " 75%,", " );content:'';display:block;height:calc( 100% - ", "px - 5px );position:absolute;right:0;top:", "px;width:", ";}&[aria-selected='true']{flex-shrink:0;}&[aria-selected='true']:before{display:none;}"], backgroundColor, fontWeight, (0, _hexToAlpha.hexToAlpha)(backgroundColor, 0), (0, _hexToAlpha.hexToAlpha)(backgroundColor, 1), (0, _hexToAlpha.hexToAlpha)(backgroundColor, 1), borderWidth * 2, borderWidth, (0, _spaceMixin.spaceMixin)('sm')(props));
  })(props);
};
exports.TabMixin = TabMixin;